import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BottomBar from "components/bottom-bar";
import { Button } from "components/button";

export default function PrintShippingLabel() {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { labelUrl } = location.state || {};

  // Get current language for navigation
  const currentLang = i18n.language === "de" ? "de-DE" : "en-US";

  const handlePrintLabel = () => {
    if (labelUrl) {
      window.open(labelUrl, "_blank");
    }
  };

  const handleDone = () => {
    navigate(`/${currentLang}/store/shipping`);
  };

  return (
    <div className="flex flex-col h-[calc(100vh-81px)]">
      <div className="flex flex-grow flex-col items-center justify-center px-6 py-4 text-center">
        <h1 className="text-4xl font-semibold text-gray-900 mb-4">
          Shipping label ready
        </h1>
        <p className="text-lg text-gray-600 mb-12">
          Print and attach it to the package.
        </p>

        <div className="flex flex-col gap-4 w-full max-w-md">
          <Button
            onClick={handlePrintLabel}
            className="px-8 py-4 text-lg w-full"
            disabled={!labelUrl}
          >
            Print Label
          </Button>

          <Button
            variant="secondary"
            onClick={handleDone}
            className="px-8 py-4 text-lg w-full"
          >
            Done
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
